<template>
    <div>
        <template v-if="event.action != 'project_user_invite_accept'">
        {{ userName }}
        </template>

        {{ action }}

        <i>{{ event.data.email }}</i>

        <template v-if="event.action == 'project_user_invite'">
          {{ $t('toJoinProject') }}
        </template>

        <template v-if="event.action == 'project_user_invite_accept'">
          {{ $t('hasJoinedProject') }}
        </template>

        <template v-if="event.action == 'project_user_deleted'">
          {{ $t('fromTheProject') }}
        </template>
    </div>
</template>

<script>
import Pluralize from 'pluralize'

export default {
    name: "Event",
    props: {
        event: {
            type: Object
        }
    },
    data: function() {
        return {
            events: {
                project_user_invite: "sent invite to",
                project_user_invite_accept: "",
                project_user_deleted: "deleted"
            }
        }
    },
    computed: {
        action() {
            return this.events[this.event.action]
        },

        userName() {
            let user = this.$store.getters.getUser
            return user.uuid == this.event.user.uuid ? "You" : this.event.user.name
        }
    },
    methods: {
        pluralize(val) {
            return Pluralize(val)
        }
    }
}
</script>
